import React from "react";
import api from "../../api/requests";

const initialData = {};

export default function useRequestCard() {
  const [requestCard, setRequestCard] = React.useState(initialData);

  function getRequestCard(id) {
    api.getRequestCard(id).then(({ data }) => setRequestCard(data));
  }

  return { requestCard, getRequestCard };
}
